import { NextPage } from 'next'
import Head from 'next/head'
import React, { useEffect, useState } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'

import SeoToolContainer from '../../components/seo-tools/SeoToolContainer/SeoToolContainer'
import { CommonModalsLightProvider } from '../../context/CommonModalsLightContext'
import { SizesProvider } from '../../hooks/useSizes'
import { getPostConfigFromQuery, getPostFromQuery, getUserFromQuery } from '../../utils/nextUtils'
import { BlogPostConfig, FrontendUser, GhostPost } from '../../utils/types'

type PageProps = {
  user: FrontendUser
  tool: string | string[]
  post: GhostPost
  postConfig: BlogPostConfig
}

const SeoTool: NextPage<PageProps> = ({ user, tool, post, postConfig }) => {
  const convertedTool = typeof tool === 'string' ? tool : ''
  const [loaded, setLoaded] = useState(false)
  const [queryClient] = React.useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
          },
        },
      }),
  )

  useEffect(() => {
    setLoaded(true)
  }, [])

  const url = 'https://chordchord.com/' + post.slug

  return (
    <>
      <Head>
        <title>{post.meta_title}</title>
        <meta name='description' content={post.meta_description || ''} />
        <meta property='og:url' content={url} />
        <meta property='og:type' content='article' />
        <meta property='og:title' content={post.og_title || ''} />
        <meta property='og:image' content={post.og_image || ''} />
        <meta property='og:description' content={post.og_description || post.meta_description || ''} />
        <meta property='article:published_time' content={post.published_at || ''} />
        <meta property='og:updated_time' content={post.updated_at || ''} />
        {post.canonical_url && post.canonical_url !== '' && <link rel='canonical' href={post.canonical_url} />}
      </Head>
      <QueryClientProvider client={queryClient}>
        <SizesProvider>
          <CommonModalsLightProvider>
            {loaded ? <SeoToolContainer tool={convertedTool} post={post} postConfig={postConfig} /> : null}
          </CommonModalsLightProvider>
        </SizesProvider>
      </QueryClientProvider>
    </>
  )
}

SeoTool.getInitialProps = async ({ query }) => {
  return {
    user: getUserFromQuery(query),
    tool: query.tool || '',
    post: getPostFromQuery(query),
    postConfig: getPostConfigFromQuery(query),
  }
}

export default SeoTool
